import { PanelDesignTokens } from '@primeuix/themes/aura/panel';

export const panelTokens: PanelDesignTokens = {
  root: {
    background: '{content.background}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{content.color}',
  },
  header: {
    background: 'transparent',
    color: '{text.color}',
    borderColor: '{content.border.color}',
    borderRadius: '0',
    borderWidth: '0',
    padding: '1.125rem',
  },
  toggleableHeader: {
    padding: '0.375rem 1.125rem',
  },
  title: {
    fontWeight: '600',
  },
  content: {
    padding: '0 1.125rem 1.125rem 1.125rem',
  },
  footer: {
    padding: '0 1.125rem 1.125rem 1.125rem',
  },
};
